import React from 'react';
import { Link } from 'gatsby';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';
import Rocket from 'src/data/images/new_rocket.svg';

const scrollToTop = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

const CtaBottomSection = ({ to, onCtaClick, title, subtitle, sessionCards, buttonText, footerText }) => {
  const Cta = to ? Link : 'button';
  return (
    <>
      {/* Rocket - in normal flow, no background */}
      <div
        css={{
          position: 'relative',
          zIndex: 3,
          background: `linear-gradient(to bottom, ${colors.white} 50%, ${colors.purple} 50%)`,
          height: 190,
          [mediaQueries.tabletPortraitUp]: {
            height: 295,
          },
        }}
      >
        <div
          css={{
            backgroundImage: `url(${Rocket})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            height: '100%',
          }}
        />
      </div>
      {/* Purple section - pulls up behind bottom half of rocket */}
      <section
        css={{
          padding: '2.5rem 2rem 4rem',
          backgroundColor: colors.purple,
          textAlign: 'center',
          [mediaQueries.phoneOnly]: {
            padding: '2rem 1rem 3rem',
          },
        }}
      >
        <div
          css={{
            maxWidth: 700,
            margin: '0 auto',
          }}
        >
          <h3
            css={{
              fontSize: '2rem',
              marginBottom: '1rem',
              color: colors.white,
              fontWeight: 700,
              [mediaQueries.phoneOnly]: {
                fontSize: '1.5rem',
              },
            }}
          >
            {title}
          </h3>
          {subtitle && (
            <div
              css={{
                fontSize: '1.125rem',
                color: colors.white,
                marginBottom: '2rem',
                opacity: 0.9,
                lineHeight: 1.6,
                [mediaQueries.phoneOnly]: {
                  fontSize: '1rem',
                },
              }}
            >
              {subtitle}
            </div>
          )}
          {sessionCards && sessionCards.length > 0 && (
            <div
              css={{
                display: 'flex',
                justifyContent: 'center',
                gap: '1rem',
                marginBottom: '2rem',
                [mediaQueries.phoneOnly]: {
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '0.75rem',
                },
              }}
            >
              {sessionCards.map((session, index) => (
                <div
                  key={index}
                  onClick={scrollToTop}
                  css={{
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.25)',
                    borderRadius: 12,
                    padding: '1rem 1.5rem',
                    color: colors.white,
                    backdropFilter: 'blur(10px)',
                    cursor: 'pointer',
                    textAlign: 'center',
                    flex: '1 1 0',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.2)',
                      transform: 'translateY(-2px)',
                    },
                  }}
                >
                  <div css={{ fontSize: 15, fontWeight: 700, marginBottom: 8, whiteSpace: 'nowrap' }}>
                    {session.date}
                  </div>
                  <div css={{ marginBottom: 8 }}>
                    <span
                      css={{
                        fontSize: 12,
                        fontWeight: 600,
                        padding: '3px 10px',
                        borderRadius: 50,
                        backgroundColor: session.label === 'Prochaine session'
                          ? 'rgba(52, 211, 153, 0.2)'
                          : 'rgba(251, 191, 35, 0.2)',
                        color: session.label === 'Prochaine session'
                          ? '#34D399'
                          : '#FBBF23',
                      }}
                    >
                      {session.label}
                    </span>
                  </div>
                  <div css={{ fontSize: 12, opacity: 0.6 }}>
                    {session.format}
                  </div>
                </div>
              ))}
            </div>
          )}
          <Cta
            to={to}
            onClick={onCtaClick}
            css={{
              display: 'inline-block',
              backgroundColor: colors.yellow,
              color: colors.purpleDark,
              padding: '1rem 2.5rem',
              borderRadius: 50,
              border: 'none',
              fontWeight: 700,
              fontSize: '1.1rem',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
              },
            }}
          >
            {buttonText}
          </Cta>
          {footerText && (
            <p
              css={{
                marginTop: '1rem',
                color: colors.white,
                opacity: 0.8,
                fontSize: '0.9rem',
              }}
            >
              {footerText}
            </p>
          )}
        </div>
      </section>
    </>
  );
};

export default CtaBottomSection;
